import { lazy } from "@loadable/component";
import MatxLayout from "../components/template/layout/MatxLayout";
import AuthGuard from "./AuthGuard";
import PrivateRoutes from "./PrivateRoutes";
import PublicRoutes from "./PublicRoutes";
import RootRoutes from "./RootRoutes";

// Menu
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

const AppRoutes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [...PrivateRoutes],
  },
  ...PublicRoutes,
  { path: "/404", element: <NotFoundPage /> },
  { path: "/", element: <RootRoutes /> },
  { path: "*", element: <NotFoundPage /> },
];
export default AppRoutes;
